<template>
  <div class="space-y-4">
    <!-- Player Toggle -->
    <div class="flex items-center justify-between">
      <div class="flex flex-col flex-1">
        <label
          for="role-player"
          class="text-sm font-medium"
          :class="isPlayerDisabled ? 'text-gray-400' : 'text-gray-700'"
        >
          Player
        </label>
        <span
          class="text-xs"
          :class="isPlayerDisabled ? 'text-gray-400' : 'text-gray-500'"
        >
          Athlete in your organization
        </span>
      </div>
      <div
        v-tooltip.left="
          isPlayerDisabled ? 'Cannot be both Player and Staff' : null
        "
      >
        <ToggleSwitch
          id="role-player"
          v-model="isPlayer"
          :disabled="isPlayerDisabled"
        />
      </div>
    </div>

    <!-- Contact Toggle -->
    <div class="flex items-center justify-between">
      <div class="flex flex-col flex-1">
        <label
          for="role-contact"
          class="text-sm font-medium"
          :class="isContactDisabled ? 'text-gray-400' : 'text-gray-700'"
        >
          Parent
        </label>
        <span
          class="text-xs"
          :class="isContactDisabled ? 'text-gray-400' : 'text-gray-500'"
        >
          Parent or guardian of a player
        </span>
      </div>
      <div
        v-tooltip.left="
          isContactDisabled
            ? 'Parent role cannot be removed once assigned'
            : null
        "
      >
        <ToggleSwitch
          id="role-contact"
          v-model="isContact"
          :disabled="isContactDisabled"
        />
      </div>
    </div>

    <!-- Staff Toggle -->
    <div class="flex items-center justify-between">
      <div class="flex flex-col flex-1">
        <label
          for="role-coach"
          class="text-sm font-medium"
          :class="isCoachDisabled ? 'text-gray-400' : 'text-gray-700'"
        >
          Staff
        </label>
        <span
          class="text-xs"
          :class="isCoachDisabled ? 'text-gray-400' : 'text-gray-500'"
        >
          Staff member in your organization
        </span>
      </div>
      <div
        v-tooltip.left="
          isCoachDisabled ? 'Cannot be both Player and Staff' : null
        "
      >
        <ToggleSwitch
          id="role-coach"
          v-model="isCoach"
          :disabled="isCoachDisabled"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ToggleSwitch from "primevue/toggleswitch";

interface Props {
  isContactDisabled?: boolean;
}

defineProps<Props>();

const isPlayer = defineModel<boolean>("isPlayer", { default: false });
const isContact = defineModel<boolean>("isContact", { default: false });
const isCoach = defineModel<boolean>("isCoach", { default: false });

// Player and Coach are mutually exclusive
const isPlayerDisabled = computed(() => isCoach.value);
const isCoachDisabled = computed(() => isPlayer.value);
</script>
